/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import {
  Redirect,
  Route,
  Switch,
  matchPath,
  useLocation,
} from "react-router-dom"
import { AppDispatch } from "../.."
import AlertComponent from "../../components/AlertComponent"
import constants from "../../constant/constant"
import {
  allPages,
  directory,
  loginByQRCodePage,
  loginPage,
} from "../../constant/tablet/pages"
import { clearAlert } from "../../globalStore/alertStore"
import { logout } from "../../globalStore/authStore"
import LogoMark from "../../source/img/logomark.png"
import TabletAuth from "./Auth"
import { useTabletContexts } from "./context/context"
import { CSS_PROPERTY, HEADER } from "./cssProperties/tablet"
import DateTime from "../../components/DateTime"
import { getToday } from "../../globalStore/dateStore"

export const TabletBody = () => {
  const location = useLocation()

  const dispatch: AppDispatch = useDispatch()

  const { initContexts, Component: TabletContexts } = useTabletContexts()

  // ロケーション変更時にページ名を入れる
  useEffect(() => {
    dispatch(clearAlert())
    const matchObject = allPages.find(
      (page) =>
        !!matchPath(location.pathname, {
          path: page.Route.path,
          exact: true,
          strict: true,
        })
    )

    if (matchObject) {
      document.title = `${constants.APP_NAME} - ${matchObject.機能名}`
      // ログインページの場合、点呼ヘッダのデータを空にする
      if (location.pathname === loginPage.Route.path) {
        initContexts()
      }
      return
    }
  }, [dispatch, location.pathname, initContexts])

  // ページを開く方法がリロードの場合、強制的にログアウトする
  useEffect(() => {
    let performanceEntries = performance.getEntriesByType("navigation")
    const performanceNavigationTiming = performanceEntries.find(
      (p) => p instanceof PerformanceNavigationTiming && p.type != null
    ) as PerformanceNavigationTiming

    if (
      performanceNavigationTiming != null &&
      performanceNavigationTiming.type === "reload" &&
      location.pathname !== loginPage.Route.path
    ) {
      dispatch(logout())
    }
  }, [])

  useEffect(() => {
    dispatch(getToday())
    const getTodayInterval = setInterval(() => {
      dispatch(getToday())
    }, 5 * 60 * 1000)
    return () => {
      clearInterval(getTodayInterval)
    }
  }, [])

  return (
    <>
      <header style={HEADER.STYLE} className="py-2">
        <span>
          <img src={LogoMark} alt="" style={HEADER.LOGO_MARK} />
        </span>
        <span
          className="position-absolute end-0"
          style={{
            marginRight: "24px",
          }}>
          現在時刻:
          <DateTime />
        </span>
      </header>
      <div
        style={{
          position: "fixed",
          top: CSS_PROPERTY.HEADER_HEIGHT,
          zIndex: "1000",
          width: "100%",
        }}>
        <AlertComponent className="w-100"></AlertComponent>
      </div>
      <div
        style={{
          backgroundColor: "#f1f1f1",
          position: "relative",
          display: "block",
          top: CSS_PROPERTY.HEADER_HEIGHT,
          padding: "1rem 4rem 1rem 4rem",
          width: "100%",
          height: `calc(100% - ${CSS_PROPERTY.HEADER_HEIGHT})`,
          fontSize: CSS_PROPERTY.TABLET_FONT_SIZE,
        }}>
        <TabletContexts>
          <Switch>
            <Route {...loginByQRCodePage.Route} />
            <Route {...loginPage.Route} />
            <TabletAuth>
              {allPages.map((page, i) => (
                <Route key={i} {...page.Route} />
              ))}
            </TabletAuth>
            <Redirect from="/" to={directory + "/login"} />
          </Switch>
        </TabletContexts>
      </div>
    </>
  )
}
